import { Image } from '@monofe/ui-common/misc';
import { m } from 'framer-motion';
import { memo, useCallback } from 'react';
import SideMenuDownloadView from './SideMenuDownloadView';
import SideMenuItemView from './SideMenuItemView';
import {
    StyleElement,
    animationStateForElement,
    animationVariantsForElement,
    classNameForElement,
    styleForElement,
} from './SideMenuView.style';
import type { IHamburgerSideMenuViewProperties } from './interface';

function View(properties: IHamburgerSideMenuViewProperties): JSX.Element {
    const style = useCallback(
        (element: StyleElement) => styleForElement(element, properties),
        [properties],
    );
    const className = useCallback(
        (element: StyleElement) => classNameForElement(element, properties),
        [properties],
    );

    return (
        <m.aside
            aria-hidden={!properties.isShowing}
            animate={animationStateForElement(StyleElement.Container, properties)}
            variants={animationVariantsForElement(StyleElement.Container)}
            className={className(StyleElement.Container)}
            style={style(StyleElement.Container)}
        >
            <m.div
                animate={animationStateForElement(StyleElement.ImageContainer, properties)}
                variants={animationVariantsForElement(StyleElement.ImageContainer)}
                className={className(StyleElement.ImageContainer)}
                style={style(StyleElement.ImageContainer)}
            >
                <Image
                    urls={properties.foregroundImage.urls}
                    mode={properties.foregroundImage.mode}
                    className={className(StyleElement.Image)}
                    style={style(StyleElement.Image)}
                />
            </m.div>
            <m.ul
                animate={animationStateForElement(StyleElement.ListContainer, properties)}
                variants={animationVariantsForElement(StyleElement.ListContainer)}
                className={className(StyleElement.ListContainer)}
                style={style(StyleElement.ListContainer)}
            >
                {properties.items.map((model, index) => (
                    <li key={`SideMenuItemView-${index}`}>
                        <SideMenuItemView {...model} />
                    </li>
                ))}
            </m.ul>
            <SideMenuDownloadView {...properties.download} />
        </m.aside>
    );
}

export default memo(View);
